import { styled } from '@mui/material/styles';

import { THEME } from '../../theming/theme';

const paddingMobile = {
  [THEME.DA_DIREKT_THEME]: '0 1rem 0',
  [THEME.DENTOLO_LEFT_ALIGN_THEME]: '0 1rem 1rem',
  DEFAULT: 0,
};

const paddingDesktop = {
  [THEME.DENTOLO_LEFT_ALIGN_THEME]: '0 4rem 0',
  DEFAULT: 0,
};

/* eslint-disable import/prefer-default-export */
export const StyledPageInnerContainer = styled('div')(({ theme }) => ({
  flexGrow: 1,
  padding: paddingMobile,

  [theme.breakpoints.up('desktop')]: {
    padding: paddingDesktop[theme?.name] || paddingDesktop.DEFAULT,
  },
}));
/* eslint-enable import/prefer-default-export */
